/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Execution_Modal_View_In_Portfolio_CtaInputs */

const en_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View in portfolio`)
};

const de_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Portfolio anzeigen`)
};

const pt_br2_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver no portfólio`)
};

const tr_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföyde görüntüle`)
};

const zh_cn2_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在投资组合中查看`)
};

const zh_hk2_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在投資組合中查看`)
};

const ko_kr2_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오에서 보기`)
};

const ru_ru2_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть в портфеле`)
};

const es_419_toast_execution_modal_view_in_portfolio_cta = /** @type {(inputs: Toast_Execution_Modal_View_In_Portfolio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver en el portafolio`)
};

/**
* | output |
* | --- |
* | "View in portfolio" |
*
* @param {Toast_Execution_Modal_View_In_Portfolio_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const toast_execution_modal_view_in_portfolio_cta = /** @type {((inputs?: Toast_Execution_Modal_View_In_Portfolio_CtaInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Execution_Modal_View_In_Portfolio_CtaInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_execution_modal_view_in_portfolio_cta(inputs)
	if (locale === "de") return de_toast_execution_modal_view_in_portfolio_cta(inputs)
	if (locale === "pt-BR") return pt_br2_toast_execution_modal_view_in_portfolio_cta(inputs)
	if (locale === "tr") return tr_toast_execution_modal_view_in_portfolio_cta(inputs)
	if (locale === "zh-CN") return zh_cn2_toast_execution_modal_view_in_portfolio_cta(inputs)
	if (locale === "zh-HK") return zh_hk2_toast_execution_modal_view_in_portfolio_cta(inputs)
	if (locale === "ko-KR") return ko_kr2_toast_execution_modal_view_in_portfolio_cta(inputs)
	if (locale === "ru-RU") return ru_ru2_toast_execution_modal_view_in_portfolio_cta(inputs)
	return es_419_toast_execution_modal_view_in_portfolio_cta(inputs)
});